import React from 'react'
import { Redirect } from 'react-router-dom'
import { useSelector } from 'react-redux'

export default function Login() {
    const { token } = useSelector(state => state.main)
    const isLoggedIn = token !== null

    return (
        <React.Fragment>
            {isLoggedIn && <Redirect to={{ pathname: '/dashboard' }} />}
            {!isLoggedIn && <Redirect to={{ pathname: '/login' }} />}
        </React.Fragment>
    )
}